// assets/inquire-forms.js
(() => {
  const ENABLE_HASH_OPEN = false; // không auto-open qua #inquire-<id>

  const state = new Map(); // formId -> { openerEl, originalText, open, wrap }

  const getWrap = (id) =>
    document.getElementById(`inquire-form-${id}`) ||
    document.querySelector(`[data-inquire-form-id="${id}"]`) ||
    document.querySelector(`[data-forms-id="${id}"]`) ||
    null;

  function getIdFromEl(el) {
    if (!el) return null;
    const dataId =
      el.getAttribute('data-inquire-id') ||
      el.closest('[data-inquire-id]')?.getAttribute('data-inquire-id');
    if (dataId && /^\d+$/.test(dataId)) return dataId;
    const href =
      (el.getAttribute('href') || el.closest('a')?.getAttribute('href') || '')
        .toLowerCase();
    const m = href.match(/#inquire-(\d+)/i);
    return m ? m[1] : null;
  }

  function ensureState(id, openerEl) {
    let st = state.get(id);
    if (!st) {
      st = { openerEl, originalText: openerEl?.textContent ?? null, open: false, wrap: null };
      state.set(id, st);
    } else {
      if (!st.originalText && openerEl) st.originalText = openerEl.textContent ?? null;
      if (openerEl) st.openerEl = openerEl;
    }
    if (!st.wrap) st.wrap = getWrap(id);
    return st;
  }

  // ---------- show/hide helpers ----------
  function forceVisible(el) {
    if (!el) return;
    el.classList.remove('inquire-prehide');
    el.hidden = false;
    el.removeAttribute('aria-hidden');
    el.classList.add('inquire-visible');

    // Gỡ các inline styles hay gây ẩn
    if (el.style) {
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('pointer-events');
    }
    // Gỡ trên 3 cấp cha gần nhất nếu họ bị ẩn inline
    let p = el.parentElement, steps = 0;
    while (p && steps++ < 3) {
      if (p.hidden) p.hidden = false;
      if (p.style) {
        p.style.removeProperty('display');
        p.style.removeProperty('visibility');
        p.style.removeProperty('opacity');
      }
      p = p.parentElement;
    }

    // Nếu con bên trong bị style inline display:none → bỏ
    el.querySelectorAll('[style*="display"]').forEach(n => {
      const v = (n.style.display || '').trim();
      if (v === 'none') n.style.removeProperty('display');
    });
  }

  function safeHide(el) {
    if (!el) return;
    el.hidden = true;
    el.classList.remove('inquire-visible'); // ẩn thì bỏ class hiển thị
    // không add lại prehide (tránh height:0 khi đang ẩn bằng hidden)
  }

  // Đợi app render xong trong wrapper rồi chuyển từ prehide -> hidden (không chớp)
  function armPrehideToHidden(id) {
    const st = ensureState(id);
    const wrap = st.wrap; if (!wrap) return;

    const ready = () =>
      wrap.querySelector('form button[type="submit"], form input[type="submit"]') ||
      wrap.querySelector('form, [class*="form"]');

    if (ready()) { safeHide(wrap); return; }

    const mo = new MutationObserver(() => {
      if (ready()) { safeHide(wrap); mo.disconnect(); }
    });
    mo.observe(wrap, { childList: true, subtree: true });

    // Deadline tối đa 2s
    setTimeout(() => { if (ready()) { safeHide(wrap); mo.disconnect(); } }, 2000);
  }

  function showForm(id, openerEl) {
    const st = ensureState(id, openerEl);
    const wrap = st.wrap || getWrap(id);
    if (!wrap) {
      console.warn('[Inquire] Không tìm thấy wrapper cho id=', id, '(kỳ vọng #inquire-form-' + id + ')');
      return;
    }
    forceVisible(wrap);
    wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const first = wrap.querySelector('input,textarea,select,button');
    if (first) setTimeout(() => { try { first.focus(); } catch(_){} }, 120);

    if (st.openerEl) {
      st.openerEl.textContent = 'Cancel';
      st.openerEl.setAttribute('aria-expanded', 'true');
      st.openerEl.classList.add('inquire-open');
    }
    st.open = true;
  }

  function hideForm(id) {
    const st = ensureState(id);
    const wrap = st.wrap || getWrap(id);
    if (wrap) safeHide(wrap);
    if (st.openerEl) {
      if (st.originalText != null) st.openerEl.textContent = st.originalText;
      st.openerEl.setAttribute('aria-expanded', 'false');
      st.openerEl.classList.remove('inquire-open');
    }
    st.open = false;
  }

  function toggleFrom(el) {
    const id = getIdFromEl(el);
    if (!id) return;
    const st = ensureState(id, el);
    st.open ? hideForm(id) : showForm(id, el);
  }

  // ---------- boot ----------
  function boot() {
    const ids = new Set();
    document.querySelectorAll('[id^="inquire-form-"]').forEach(w => {
      const id = (w.id || '').replace('inquire-form-','');
      if (/^\d+$/.test(id)) { ensureState(id); ids.add(id); }
    });
    document.querySelectorAll('[data-inquire-form-id]').forEach(w => {
      const id = w.getAttribute('data-inquire-form-id');
      if (/^\d+$/.test(id)) { ensureState(id); ids.add(id); }
    });

    ids.forEach(id => armPrehideToHidden(id));

    if (ENABLE_HASH_OPEN) {
      const m = (location.hash || '').toLowerCase().match(/#inquire-(\d+)/i);
      if (m) showForm(m[1], null);
    }
  }

  function onClick(e) {
    const el = e.target.closest('a,button,[data-inquire-id]');
    if (!el) return;
    const id = getIdFromEl(el);
    if (!id) return;
    e.preventDefault();
    toggleFrom(el);
  }

  function onKey(e) {
    if (e.key !== 'Escape') return;
    for (const [id, st] of state.entries()) if (st.open) hideForm(id);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('click', onClick, { passive: false });
  document.addEventListener('keydown', onKey);
})();
